import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BenefitsCoverageModule } from './benefits-coverage/benefits-coverage.module';
import { CoverExclusionsModule } from './covers-exclusions/covers-exclusions.module';
import { DirectDebitUiModule } from './direct-debit/direct-debit-ui.module';
import { MarketingPreferencesModule } from './marketing-preferences/marketing-preferences.module';
import { PlanDocumentsModule } from './plan-documents/plan-documents.module';
import { SkyCoversExclusionsModule } from './sky-covers-exclusions';

@NgModule({
  imports: [
    CommonModule,
    DirectDebitUiModule,
    MarketingPreferencesModule,
    PlanDocumentsModule,
    CoverExclusionsModule,
    BenefitsCoverageModule,
    SkyCoversExclusionsModule,
  ],
})
export class SharedUiBusinessComponentsModule {}
